export const zirmajmoehsReducer = (state = [], action) => {
    switch (action.type) {
        case "MJMH":
            return [...action.payload];
        default:
            return state;
    }
};
